import { ShareRangeAnalysisEventType } from "src/store/shareRangeAnalysisEvent/types";

export const SHARE_RANGE_ANALYSIS_LABEL: {
  [key in ShareRangeAnalysisEventType]: string;
} = {
  all_shareholders: "All Shareholders",
  not_voted_shareholders: "Not Voted Shareholders",
  voted_shareholders: "Voted Shareholders",
};
